import { render, staticRenderFns } from "./KelaBatches.vue?vue&type=template&id=7c81b562&scoped=true&"
import script from "./KelaBatches.vue?vue&type=script&lang=js&"
export * from "./KelaBatches.vue?vue&type=script&lang=js&"
import style0 from "./KelaBatches.vue?vue&type=style&index=0&id=7c81b562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c81b562",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSnackbar})


/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c81b562')) {
      api.createRecord('7c81b562', component.options)
    } else {
      api.reload('7c81b562', component.options)
    }
    module.hot.accept("./KelaBatches.vue?vue&type=template&id=7c81b562&scoped=true&", function () {
      api.rerender('7c81b562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/KelaBatches.vue"
export default component.exports